/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Crop_Center_StripInputs */



/**
* | output |
* | --- |
* | "Center Strip" |
*
* @param {Ocr_Crop_Center_StripInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_crop_center_strip = /** @type {((inputs?: Ocr_Crop_Center_StripInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Crop_Center_StripInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bande centrale")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mittelstreifen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Striscia centrale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Центральная полоса")
	if (locale === "es") return /** @type {LocalizedString} */ ("Franja central")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("中心条纹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("センターストリップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केंद्र पट्टी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Faixa central")
	return /** @type {LocalizedString} */ ("Center Strip")
});